/* GlobifySIM – Zielkatalog mit Regionsfilter und Freitextsuche */
(function () {
  "use strict";

  var SPRACHE = (document.documentElement.lang || "de").slice(0, 2).toLowerCase();
  var T = (window.GST || {});

  function name(z) { /* Reiseziele immer auf Englisch */ return z.en || z.de; }

  function regionName(id) {
    var alle = window.GS_REGIONEN || [];
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].id === id) return alle[i].en || alle[i].de;
    }
    return id;
  }

  function aufbauen(wurzel) {
    var raster = wurzel.querySelector("[data-gs-katalog-raster]");
    var filter = wurzel.querySelector("[data-gs-katalog-filter]");
    var feld = wurzel.querySelector("[data-gs-katalog-feld]");
    var zaehler = wurzel.querySelector("[data-gs-katalog-zahl]");
    if (!raster) return;

    var muster = wurzel.getAttribute("data-gs-ziel-link") || "/search?q=";
    var preis = wurzel.getAttribute("data-gs-preis") || "";
    var nurBeliebt = wurzel.getAttribute("data-gs-nur-beliebt") === "true";
    var grenze = parseInt(wurzel.getAttribute("data-gs-grenze") || "0", 10);
    var region = "alle";
    var eingabe = "";

    function passt(z) {
      if (nurBeliebt && !z.beliebt) return false;
      if (region !== "alle" && z.region !== region) return false;
      if (eingabe) {
        var q = window.GSSuche ? window.GSSuche.flach(eingabe) : eingabe.toLowerCase();
        var heu = window.GSSuche ? window.GSSuche.flach(z.de + " " + z.en + " " + z.such) : (z.de + z.en + z.such).toLowerCase();
        if (heu.indexOf(q) < 0) return false;
      }
      return true;
    }

    function zeichnen() {
      var alle = (window.GS_ZIELE || []).filter(passt);
      alle.sort(function (a, b) { return name(a).localeCompare(name(b)); });
      var zeigen = grenze > 0 && !eingabe && region === "alle" ? alle.slice(0, grenze) : alle;
      raster.innerHTML = "";
      if (!zeigen.length) {
        var leer = document.createElement("div");
        leer.className = "gs-leer";
        leer.textContent = T.kein_treffer || "No destination found.";
        raster.appendChild(leer);
      } else {
        zeigen.forEach(function (z) {
          var a = document.createElement("a");
          a.className = "gs-ziel";
          a.href = window.GSSuche ? window.GSSuche.adresse(z, muster) : muster + encodeURIComponent(name(z));
          var html = '<span class="gs-ziel__flagge">' + z.flagge + "</span><span>" +
            '<span class="gs-ziel__name">' + name(z) + "</span><br>" +
            '<span class="gs-ziel__unten">' + regionName(z.region) + "</span></span>";
          if (preis) html += '<span class="gs-ziel__preis">' + (T.ab || "ab") + " " + preis + "</span>";
          a.innerHTML = html;
          raster.appendChild(a);
        });
      }
      if (zaehler) {
        var wort = alle.length === 1
          ? (T.gefunden_eins || "destination found")
          : (T.gefunden_viele || "destinations found");
        zaehler.textContent = alle.length + " " + wort;
      }
    }

    if (filter) {
      var knoepfe = [{ id: "alle", text: T.filter_alle || "Alle" }];
      (window.GS_REGIONEN || []).forEach(function (r) {
        knoepfe.push({ id: r.id, text: r.en || r.de });
      });
      knoepfe.forEach(function (k, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.textContent = k.text;
        if (i === 0) b.className = "ist-aktiv";
        b.addEventListener("click", function () {
          region = k.id;
          var alleK = filter.querySelectorAll("button");
          for (var j = 0; j < alleK.length; j++) alleK[j].classList.toggle("ist-aktiv", alleK[j] === b);
          zeichnen();
        });
        filter.appendChild(b);
      });
    }

    if (feld) {
      feld.addEventListener("input", function () {
        eingabe = feld.value.trim();
        zeichnen();
      });
    }

    zeichnen();
  }

  document.addEventListener("DOMContentLoaded", function () {
    var alle = document.querySelectorAll("[data-gs-katalog]");
    for (var i = 0; i < alle.length; i++) aufbauen(alle[i]);
  });
})();
